<!--
 * @Author: Czy
 * @Date: 2021-08-23 10:54:39
 * @LastEditTime: 2021-12-23 14:10:00
 * @FilePath: /plant-protection-association/src/App.vue
 *  
-->
<template>
  <div id="app">
    <Header></Header>
    <RotationChart></RotationChart>
    <router-view />
    <suspension v-if="showSusp" @showModal="showModal1" />
    <div class="mid-showSusp hidden-xs">
      <i
        class="glyphicon glyphicon-chevron-left susp-icon"
        v-if="showSusp"
        style="font-size: 26px; color: #192989"
        @click="showSusp = false"
      ></i>
      <i
        class="glyphicon glyphicon-chevron-right susp-icon"
        v-else
        style="font-size: 26px; color: #192989"
        @click="showSusp = true"
      ></i>
    </div>
    <BrandLogo></BrandLogo>
    <Footer></Footer>
    <GoTop></GoTop>
    <Modal
      v-if="showModal"
      :joinExShow="joinExShow"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import BrandLogo from "./components/BrandLogo.vue";
import Modal from "./components/modal.vue";
import RotationChart from "./components/RotationChart.vue";
import suspension from "./components/suspension.vue";
export default {
  components: { BrandLogo, RotationChart, suspension, Modal },
  name: "App",
  data() {
    return {
      showModal: false,
      joinExShow: 0,
      showSusp: true
    };
  },
  mounted() {
    console.log("jinlai", this.bus);
    this.bus.$on("showModal", res => {
      // console.log('输出了',res);
      this.showModal1(res);
    });
  },
  methods: {
    showModal1(e) {
      console.log("eee", e);
      this.showModal = true;
      this.joinExShow = e;
    }
  }
};
</script>

<style>
#app {
  line-height: 1.5;
}
.mid-showSusp {
  position: fixed;
  top: 400px;
  left: 20px;
  z-index: 998;
}
</style>



// WEBPACK FOOTER //
// src/App.vue